import { lazy } from 'react';
import type { RouteObject } from 'react-router';
import CenteneRoutes from '@@/modules/portal/centene/CenteneRoutesDefinition';
import PbrRoutes from '@@/modules/portal/proficiency-based-routing/PbrRoutesDefinition';

import QicRoutes from '@@/modules/portal/qic/QicRoutesDefinition';
import CloudscapeWrapper from './layouts/CloudscapeWrapper';
import AuthProvider from '@@/products/portal/contexts/AuthProvider';
import InvalidInstancePage from './pages/invalid-instance-page';
import CxPortalWrapper from '@@/products/portal/layouts/CxPortalWrapper';
import BulkEditRoutes from '@@/products/portal/modules/bulk-edit/BulkEditRoutesDefinition';
import AcgrRoutes from '@@/products/portal/modules/acgr/RoutesDefinition';
import GraclRoutes from '@@/products/portal/modules/gracl/GraclRoutesDefinition';
import InsightsRoutes from '@@/modules/portal/insights/RoutesDefinition';
import KnowledgeManagementRoutes from '@@/modules/portal/knowledge-management/RoutesDefinition';
import DfcRoutes from '@@/modules/portal/dfc/RoutesDefinition';
import { campaignsRouteDefinitions } from '@@/modules/portal/campaigns/routes-definitions';
const ShadcnHomePage = lazy(() => import('./components/home-page/HomePage'));
const CxPortalHome = lazy(() => import('@@/products/portal/pages/cx-portal-home'));

const portalRoutes: RouteObject[] = [
  {
    path: 'portal',
    element: <AuthProvider />,
    children: [
      {
        element: <CxPortalWrapper />,
        children: [
          {
            index: true,
            element: <CxPortalHome />
          }
        ]
      },
      {
        element: <CloudscapeWrapper />,
        children: CenteneRoutes
      },
      {
        element: <CxPortalWrapper />,
        children: [
          {
            index: true,
            element: <ShadcnHomePage />
          },
          ...PbrRoutes,

          ...QicRoutes,
          ...BulkEditRoutes,
          ...AcgrRoutes,
          ...GraclRoutes,
          ...DfcRoutes,
          ...InsightsRoutes,
          ...campaignsRouteDefinitions,
          ...KnowledgeManagementRoutes
        ]
      },
      {
        path: 'invalid-instance',
        element: <InvalidInstancePage />
      }
    ]
  }
];

export default portalRoutes;
